import Vue from 'vue'
import Vuex from 'vuex'
import actions from '@/store/actions'
import mutations from '@/store/mutations'
import getters from '@/store/getters'
import modules from './modules'
import localStoragePlugin, { getDefaultState } from '@/store/plugins/localStoragePlugin'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    CONSTS: getDefaultState(
      'CONSTS',
      {
        serviceEventTypes: [],
        availableHolidaysProviders: {},
        serviceEventTypesRestricted: [],
        timeZones: []
      }
    )
  },
  actions,
  mutations,
  getters,
  modules,
  plugins: [localStoragePlugin],
  strict: process.env.DEV
})

if (module.hot) {
  module.hot.accept(['./actions', './mutations', './getters', './modules'], () => {
    const actions = require('./actions').default
    const mutations = require('./mutations').default
    const getters = require('./getters').default
    const modules = require('./modules').default
    store.hotUpdate({
      actions,
      mutations,
      getters,
      modules
    })
  })
}

export default store
